

















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class InviteStateInvited extends Vue {
  @Prop() myCode!: string;

  handleToDownload() {
    this.$common.utils.helper.toFoxONEDownloadPage(this.$i18n.locale);
  }

  handleInvite() {
    const code = this.myCode;
    this.$helper.toFusionPath(this, "basis", {
      name: "invite",
      query: { code }
    });
  }

  handleToHome() {
    this.$common.utils.helper.toFusionPath(this, "wallet", { name: "index" });
  }
}
export default InviteStateInvited;
